/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {FC} from 'react'
import {Link} from 'react-router-dom'
import clsx from 'clsx'
import {useLayout} from '../../core'
import {KTSVG, toAbsoluteUrl} from '../../../helpers'
import {AsideMenu} from './AsideMenu'

const AsideDefault: FC = () => {
  const {config, classes} = useLayout()
  const {aside} = config

  return (
    <div
      id='kt_aside'
      style={{ backgroundColor: '#159cd8', color: '#000' }}
      className={clsx('aside', classes.aside.join(' '))}
      data-kt-drawer='true'
      data-kt-drawer-name='aside'
      data-kt-drawer-activate='{default: true, lg: false}'
      data-kt-drawer-overlay='true'
      data-kt-drawer-width="{default:'200px', '300px': '250px'}"
      data-kt-drawer-direction='start'
      data-kt-drawer-toggle='#kt_aside_mobile_toggle'
    >
      {/* begin::Brand */}
      <div className='aside-logo flex-column-auto fs-2 fw-bolder h-125px' id='kt_aside_logo'>
        {/* begin::Logo */}
        {aside.theme === 'dark' && (
          <Link to='/dashboard' className="text-white">
            <img
              alt='Logo'
              className='h-125px mt-10 ms-3 logo me-0'
              src={toAbsoluteUrl('/media/logos/LOGO-OFICIAL-2023-dark.png')}
            />
            {process.env.REACT_APP_NAME_APP}
          </Link>
        )}
        {aside.theme === 'light' && (
          <Link to='/dashboard' style={{ color: "#08233F"}}>
            <img
              alt='Logo'
              className='h-50px logo me-2'
              src={toAbsoluteUrl('/media/logos/LOGO-OFICIAL-2023-dark.png')}
            />
            {process.env.REACT_APP_NAME_APP}
          </Link>
        )}
        {/* end::Logo */}

        {/* begin::Aside toggler */}
        {aside.minimize && (
          <div
            id='kt_aside_toggle'
            style={{ backgroundColor: '#159cd8', color: '#000' }}
            className='btn btn-icon w-auto px-0 btn-active-color-primary aside-toggle'
            data-kt-toggle='true'
            data-kt-toggle-state='active'
            data-kt-toggle-target='body'
            data-kt-toggle-name='aside-minimize'
          >
            <KTSVG
              path={'/media/icons/duotune/arrows/arr080.svg'}
              className={'svg-icon-1 rotate-180'}
            />
          </div>
        )}
        {/* end::Aside toggler */}
      </div>
      {/* end::Brand */}

      {/* begin::Aside menu */}
      <div className='aside-menu flex-column-fluid'>
        <AsideMenu asideMenuCSSClasses={classes.asideMenu} />
      </div>
      {/* end::Aside menu */}


      {/* end::Footer */}
    </div>
  )
}

export {AsideDefault}
